module.exports = __webpack_public_path__ + "static/img/c-books.f8f6e77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c-books.png
// module id = 6cqN
// module chunks = 1